export default __webpack_public_path__ + "static/reporting-informed-f26fda156484557a77b9b88e23d5a4bc.png";